// module
import { registerOnModalViewer } from 'weblite-web-modal-viewer'
// modals
import confirmDialog from './confirmation-dialog'
import linkMenu from './menus/active-link-menu'
import exceptionUserMenu from './menus/group-exception-user-menu'
import removedUserMenu from './menus/removed-user-menu'
import newChatModal from './new-chat'
import chatListToolbox from './chat-list-toolbox'
import chatListToolboxCulturalContentsModal from '$comp/modals/chat-list-toolbox/chat-list-toolbox-cultural-contents-modal.api'
import chatListToolboxOtherWappsModal from '$comp/modals/chat-list-toolbox/chat-list-toolbox-other-wapps-modal.api'
import selectLanguage from './select-language'
import changelog from './changelog'
import selectMenu from './select-menu'
import menus from './menus'
import inviteLink from './invite-link-modal'
import picker from './date-picker'
import loadingModal from './loading-modal'
import videoPlayer from './video-player'
import imageViewer from './image-viewer'
import mediaViewer from './media-viewer'
import joinHallDialog from './join-hall-dialog'
import toolBoxModal from '$comp/_app/components/chat/components/footer/components/send-field/components/chat-toolbox-modal/chat-toolbox-modal.api'
import bookmarkModal from './wapp-bar-menu'
import shareWappModal from './share-wapp-modal'
import bookmarkSelectionListModal from './bookmark-selection-list-modal'
import createBookmarkCollectionModal from './create-bookmark-collection-modal'
import shareContactList from './share-contact-dialog'
import permissionDialog from './permission-dialog'
import messageSeenListModal from './message-seen-list'
import editProfileDialog from './edit-profile-dialog'
import iOSCallProblemsDialog from './ios-call-problems'
import chooseChannelCallDialog from './create-hall-call/choose-call-type/choose-channel-call'
import chooseGroupCallDialog from './create-hall-call/choose-call-type/choose-group-call'
import notificationDialog from './notification-dialog'
import contactDialog from './contact-dialog'
import forwardMenu from './forward-menu'
import chooseHallCallTime from './create-hall-call/choose-call-time'
import callFeedbackDialog from './call-feedback'
import createStoryModal from './create-story'
import viewStoryModal from './view-story-modal'
import howToSyncIosContactsApi from './how-to-sync-ios-contacts'
import browserNotSupported from './browser-not-supported'
import browserOutDated from './out-dated-browser'
import osOutDated from './out-dated-os'
import forceReloadDialog from './force-update-web'
import recommendInstallTwaDialog from './recommend-install-twa'
import completeProfileWarning from './profile-completion-warning'
import staticWapps from './static-wapps'
import armanemaNotif from './armanema/notif-activation'
import armanemaNotifBlocked from './armanema/notif-blocked'
import sendInviteLinkDialog from './send-invite-link'
import sendVoiceDialog from './send-voice'
import joinHallRequestListModal from './join-channel-request-list'
import requestToJoinHallModal from './request-to-join-hall'
import callRoomIsFullDialog from './call-room-is-full'
import selectWorkspace from './select-workspace'
// $comp/_app/components/leftPanel/components/select-workspace
export const registeredModals = {
  ...confirmDialog,
  ...linkMenu,
  ...exceptionUserMenu,
  ...removedUserMenu,
  ...newChatModal,
  ...selectMenu,
  ...menus,
  ...inviteLink,
  ...picker,
  ...loadingModal,
  ...videoPlayer,
  ...imageViewer,
  ...mediaViewer,
  ...joinHallDialog,
  ...toolBoxModal,
  ...bookmarkModal,
  ...shareWappModal,
  ...bookmarkSelectionListModal,
  ...createBookmarkCollectionModal,
  ...selectLanguage,
  ...changelog,
  ...shareContactList,
  ...permissionDialog,
  ...messageSeenListModal,
  ...editProfileDialog,
  ...iOSCallProblemsDialog,
  ...chooseChannelCallDialog,
  ...chooseGroupCallDialog,
  ...notificationDialog,
  ...contactDialog,
  ...forwardMenu,
  ...chatListToolbox,
  ...chatListToolboxOtherWappsModal,
  ...chatListToolboxCulturalContentsModal,
  ...chooseHallCallTime,
  ...callFeedbackDialog,
  ...createStoryModal,
  ...viewStoryModal,
  ...howToSyncIosContactsApi,
  ...browserNotSupported,
  ...browserOutDated,
  ...osOutDated,
  ...forceReloadDialog,
  ...completeProfileWarning,
  ...staticWapps,
  ...recommendInstallTwaDialog,
  ...armanemaNotif,
  ...armanemaNotifBlocked,
  ...sendInviteLinkDialog,
  ...sendVoiceDialog,
  ...joinHallRequestListModal,
  ...requestToJoinHallModal,
  ...callRoomIsFullDialog,
  ...selectWorkspace,
}

registerOnModalViewer(registeredModals)
